import axios from 'axios';

export const lineitemchange = () => {
  document.addEventListener('DOMContentLoaded', () => {
    document.addEventListener('cart:change', async (event) => {
      const cartItems = event.detail.cart.items;

      // customizeの数を準備
      let numberOfCustomize = 0;

      const promises = cartItems.map(async (item) => {
        //____________________________________________________
        // CUSTOMIZE HAKUOSHI
        //____________________________________________________

        const colorProperty = Object.keys(item.properties).find(
          (key) => key.includes('Color') && item.properties['Color'] != ''
        );
        const lettersProperty = Object.keys(item.properties).find(
          (key) => key.includes('Letters') && item.properties['Letters'] != ''
        );
        const preOrderProperty = Object.keys(item.properties).find(
          (key) => key.includes('Preorder') && item.properties['Preorder'] != ''
        );

        // カスタマイズ箔押しの不備があった場合に、Lineitemの削除を行う
        if (colorProperty && !lettersProperty && preOrderProperty) {
          // 色が無い場合, 文字が無い場合かつ予約などのLineItemPropertyがある場合
          // 予約の日時は残して箔押し分だけ削除
          const key = item.key;
          const properties = {};
          properties['Preorder'] = item.properties['Preorder'];
          const response = await addLineItemProperty(key, properties);
        } else if (!colorProperty && lettersProperty && preOrderProperty) {
          // 色が無い場合, 文字が無い場合かつ予約などのLineItemPropertyがある場合
          // 予約の日時は残して箔押し分だけ削除
          const key = item.key;
          const properties = {};
          properties['Preorder'] = item.properties['Preorder'];
          const response = await addLineItemProperty(key, properties);
        } else if (colorProperty && !lettersProperty) {
          // 色が無い場合, 文字が無い場合
          // itemの削除と同じitemの追加
          const key = item.key;
          const variantId = item.id;
          await removeLineItem(key);
          await addLineItem(variantId);
        } else if (!colorProperty && lettersProperty) {
          // itemの削除と同じitemの追加
          const key = item.key;
          const variantId = item.id;
          await removeLineItem(key);
          await addLineItem(variantId);
        }

        // カスタマイズ箔押しがあった場合、上記の不備がなければ箔押し納期の追加
        // カスタマイズ箔押しがあった場合、LineItemに「custom-1」を一個だけ追加
        if (colorProperty && lettersProperty) {
          numberOfCustomize += 1;
          // 箔押し納期の追加
          const key = item.key;
          const thisItem = cartItems.find((item) => item.key == key);
          const properties = thisItem.properties;
          const deliveryProperty = Object.keys(properties).find(
            (key) => key.includes('納期') && item.properties['納期'] != ''
          );
          const preOrderProperty = Object.keys(properties).find(
            (key) =>
              key.includes('Preorder') && item.properties['Preorder'] != ''
          );

          // 予約商品ではないとき
          if (!deliveryProperty && !preOrderProperty) {
            properties['納期'] = '約１週間';
            const response = await addLineItemProperty(key, properties);
          }

          // 予約商品のとき
          if (!deliveryProperty && preOrderProperty) {
            if (!item.properties['Preorder'].includes('+箔押し: 納期約1週間')) {
              item.properties['Preorder'] =
                item.properties['Preorder'] + '+箔押し: 納期約1週間';
              const response = await addLineItemProperty(key, properties);
            }
          }

          // LineItemに「custom-1」がなかったら、一個だけ追加
          const custom1 = document.querySelector('[data-customize-id]');
          if (custom1) {
            const custom1Id = custom1.dataset.customizeId;
            const hasCustom1 = cartItems.some((item) => item.id == custom1Id);
            if (!hasCustom1) {
              const reaponse = await addLineItem(custom1Id);
            }
          }
        }

        //____________________________________________________
        // GIFT WRAPPING
        //____________________________________________________
        // GIFT WRAPPINGの商品が単体でカートに追加されたら、削除する
        if (item.sku.includes('GIFT-')) {
          if (!cartItems.some((item) => !item.sku.includes('GIFT-'))) {
            const key = item.key;
            const response = await removeLineItem(key);
          }
        }

        //____________________________________________________
        // CUSTOMIZE CPB
        //____________________________________________________
        // カスタマイズ商品がカートにあった場合は、URL部分を削除する
        let cbpItems = Array.from(
          document.querySelectorAll('[data-cpb-request-url]')
        );
        if (cbpItems && cbpItems.length != 0) {
          setTimeout(async () => {
            await customProductBuilderWrapper(cbpItems);
          }, 1000);
        }
      });

      await Promise.all(promises);

      // もしカスタマイズ箔押しが削除された場合は、「custom-1」も削除する
      if (numberOfCustomize <= 0) {
        const custom1 = document.querySelector('[data-customize-id]');
        if (custom1) {
          const custom1Id = custom1.dataset.customizeId;
          const custom1Element = cartItems.find((item) => item.id == custom1Id);
          if (custom1Element) {
            const custom1Key = custom1Element.key;
            const reaponse = await removeLineItem(custom1Key);
          }
        }
      }

      await refreshCart();
    });
  });
};

const removeLineItem = async (key) => {
  const data = {
    updates: {
      [key]: 0,
    },
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/update.js',
    data: data,
  });
};

const addLineItem = async (variantId) => {
  const formData = {
    items: [
      {
        id: variantId,
        quantity: 1,
      },
    ],
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/add.js',
    data: formData,
  });
};

const addLineItemProperty = async (key, propertyData) => {
  const formData = {
    id: key,
    properties: propertyData,
  };
  return await axios({
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    url: '/cart/change.js',
    data: formData,
  });
};

const refreshCart = () => {
  document.documentElement.dispatchEvent(
    new CustomEvent('cart:refresh', {
      bubbles: true,
    })
  );
};

async function customProductBuilderWrapper(cbpItems) {
  try {
    let count = 0;
    for (const el of cbpItems) {
      const requestUrl = el.getAttribute('data-cpb-request-url');
      if (requestUrl === '') continue;

      const response = await fetch(requestUrl);
      if (!response.ok) {
        console.error(
          'Request failed: ' +
            response.statusText +
            ". Can't get custom product properties"
        );
        continue;
      }

      const data = await response.json();
      let tpl = '';
      const propsObj = data.cartData[0].properties;
      for (const key in propsObj) {
        if (
          key == 'SKU' ||
          key.startsWith('_', 0) ||
          key.startsWith('View', 0)
        ) {
          continue;
        }
        tpl += '<li>' + key + ': ' + propsObj[key] + '</li>';
      }
      tpl +=
        '<li class="cpbProductAlert">注文キャンセルまたは内容変更の場合は、必ずご注文後3日以内に弊社カスタマーサポートまでご連絡くださいませ。<br>キャンセルフォームからの申請はご利用いただけません。</li>';
      el.innerHTML = tpl;
      const newElement = Array.from(
        document.querySelectorAll('[data-cpb-request-url]')
      )[count];
      newElement.innerHTML = tpl;
      count += 1;
    }
  } catch (error) {
    console.error('An error occurred:', error);
  }
}
